export default function MapSection() {
  return (
    <section id="map" className="w-full py-16 md:py-24 bg-gray-50 px-5 md:px-20">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block text-orange-500 text-xs font-semibold tracking-widest uppercase mb-2">LOCATION</span>
          <h2 className="text-2xl md:text-4xl font-bold text-gray-900 mb-2">오시는 길</h2>
          <p className="text-gray-500 text-sm">경기도 포천시 소흘읍 소흘로 11</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 md:gap-8 items-start">
          {/* 지도 */}
          <div className="lg:col-span-2 rounded-2xl overflow-hidden shadow-md border border-gray-200">
            <iframe
              title="NS-TECH 위치"
              src="https://maps.google.com/maps?q=%EA%B2%BD%EA%B8%B0%EB%8F%84+%ED%8F%AC%EC%B2%9C%EC%8B%9C+%EC%86%8C%ED%9D%98%EC%9D%8D+%EC%86%8C%ED%9D%98%EB%A1%9C+11&hl=ko&z=16&output=embed"
              width="100%"
              height="240"
              className="md:h-[400px]"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>

          {/* 회사 정보 */}
          <div className="bg-white rounded-2xl shadow-md border border-gray-100 p-5 md:p-7 flex flex-col gap-5">
            <div>
              <h3 className="text-base md:text-lg font-bold text-gray-900 mb-0.5">NS-TECH</h3>
              <p className="text-orange-500 text-xs font-medium">레이저 정밀 가공 전문</p>
            </div>

            <div className="space-y-3.5">
              {[
                { icon: 'ri-map-pin-line', label: '주소', value: '경기도 포천시 소흘읍\n소흘로 11', isMultiline: true },
                { icon: 'ri-phone-line', label: '전화', value: '031-541-1902', href: 'tel:031-541-1902' },
                { icon: 'ri-printer-line', label: '팩스', value: '031-541-1903' },
                { icon: 'ri-mail-line', label: '이메일', value: 'nstech01@naver.com', href: 'mailto:nstech01@naver.com' },
                { icon: 'ri-time-line', label: '운영시간', value: 'AM 08:00 ~ PM 18:00' },
              ].map((item, i) => (
                <div key={i} className="flex items-start gap-3">
                  <div className="w-8 h-8 flex items-center justify-center bg-orange-50 rounded-lg shrink-0">
                    <i className={`${item.icon} text-orange-500 text-sm`}></i>
                  </div>
                  <div>
                    <p className="text-xs text-gray-400 mb-0.5">{item.label}</p>
                    {item.href ? (
                      <a href={item.href} className="text-sm text-gray-700 font-medium hover:text-orange-500 transition-colors">
                        {item.value}
                      </a>
                    ) : (
                      <p className="text-sm text-gray-700 font-medium whitespace-pre-line">{item.value}</p>
                    )}
                  </div>
                </div>
              ))}
            </div>

            <a
              href="https://www.google.com/maps/search/?api=1&query=%EA%B2%BD%EA%B8%B0%EB%8F%84+%ED%8F%AC%EC%B2%9C%EC%8B%9C+%EC%86%8C%ED%9D%98%EC%9D%8D+%EC%86%8C%ED%9D%98%EB%A1%9C+11"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="w-full flex items-center justify-center gap-2 bg-orange-500 hover:bg-orange-600 text-white text-sm font-semibold py-3 rounded-xl transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-navigation-line"></i>
              길찾기
            </a>
          </div>
        </div>

        {/* 대중교통 이용 안내 */}
        <div className="mt-8 md:mt-12 bg-white rounded-2xl shadow-sm border border-gray-100 p-5 md:p-8">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-9 h-9 flex items-center justify-center bg-orange-50 rounded-xl shrink-0">
              <i className="ri-bus-line text-orange-500 text-lg"></i>
            </div>
            <h3 className="text-base md:text-lg font-bold text-gray-900">대중교통 이용 안내</h3>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {/* 버스 */}
            <div className="bg-orange-50 rounded-xl p-4">
              <div className="flex items-center gap-2 mb-3">
                <div className="w-7 h-7 flex items-center justify-center bg-orange-500 rounded-lg shrink-0">
                  <i className="ri-bus-2-line text-white text-sm"></i>
                </div>
                <span className="font-bold text-gray-900 text-sm">버스 이용</span>
              </div>
              <ul className="space-y-2.5 text-xs text-gray-700">
                <li className="flex items-start gap-2">
                  <span className="inline-block bg-gray-500 text-white text-xs font-bold px-2 py-0.5 rounded-full shrink-0 mt-0.5">일반</span>
                  <span>의정부 → 포천 방면 <strong>138번</strong> 버스 탑승 후 <strong>용산골</strong> 하차 후 무봉사거리 방면 도보 5분</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="inline-block bg-orange-500 text-white text-xs font-bold px-2 py-0.5 rounded-full shrink-0 mt-0.5">직행</span>
                  <span>경기 시외버스 <strong>3100번 3200번</strong> 탑승 후 용산골 하차 후 무봉사거리 방면 도보 5분</span>
                </li>
              </ul>
            </div>

            {/* 지하철 + 버스 환승 */}
            <div className="bg-gray-50 rounded-xl p-4">
              <div className="flex items-center gap-2 mb-3">
                <div className="w-7 h-7 flex items-center justify-center bg-gray-700 rounded-lg shrink-0">
                  <i className="ri-subway-line text-white text-sm"></i>
                </div>
                <span className="font-bold text-gray-900 text-sm">지하철 + 버스 환승</span>
              </div>
              <ul className="space-y-2.5 text-xs text-gray-700">
                <li className="flex items-start gap-2">
                  <span className="inline-block bg-green-600 text-white text-xs font-bold px-2 py-0.5 rounded-full shrink-0 mt-0.5">1호선</span>
                  <span><strong>의정부역</strong> 하차 → 동부광장 버스 정류장에서 <strong>138번 138-5번 137번</strong> 탑승 용산골 하차 후 무봉사거리 방면 도보 5분</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="inline-block bg-green-600 text-white text-xs font-bold px-2 py-0.5 rounded-full shrink-0 mt-0.5">1호선</span>
                  <span><strong>소요산역</strong> 하차 → 포천 방면 버스 환승 후 소흘읍 하차</span>
                </li>
              </ul>
            </div>

            {/* 자가용 */}
            <div className="bg-gray-50 rounded-xl p-4">
              <div className="flex items-center gap-2 mb-3">
                <div className="w-7 h-7 flex items-center justify-center bg-gray-700 rounded-lg shrink-0">
                  <i className="ri-car-line text-white text-sm"></i>
                </div>
                <span className="font-bold text-gray-900 text-sm">자가용 이용</span>
              </div>
              <ul className="space-y-2.5 text-xs text-gray-700">
                <li className="flex items-start gap-2">
                  <span className="inline-block bg-gray-500 text-white text-xs font-bold px-2 py-0.5 rounded-full shrink-0 mt-0.5">서울</span>
                  <span>서울 → 의정부 → <strong>43번 국도</strong> 포천 방면 → 소흘읍 진입 → 소흘로 11</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="inline-block bg-orange-500 text-white text-xs font-bold px-2 py-0.5 rounded-full shrink-0 mt-0.5">고속도로</span>
                  <span>세종포천고속도로 <strong>포천IC</strong> 하차 → 소흘읍 방면 약 10분</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-5 flex items-start gap-2 bg-orange-50 rounded-xl px-4 py-3">
            <div className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5">
              <i className="ri-information-line text-orange-500 text-sm"></i>
            </div>
            <p className="text-xs text-gray-600 leading-relaxed">
              방문 전 사전 연락 주시면 더욱 정확한 안내를 드릴 수 있습니다.&nbsp;
              <a href="tel:031-541-1902" className="text-orange-500 font-semibold hover:underline">031-541-1902</a>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
